import { Link } from 'react-router';
import { getAllProjects } from '../../lib/projects.js';
import { getDisciplineBySlug } from '../../lib/disciplines.js';
import { useDocumentTitle } from '../../lib/useDocumentTitle.js';

export default function ProjectsList() {
  useDocumentTitle('Projects');
  const projects = getAllProjects();

  return (
    <div className="container" style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
      <h1>Projects</h1>
      <p className="meta">Work built by club members, across all disciplines.</p>

      <ul className="hairline-list">
        {projects.map((project) => {
          const discipline = getDisciplineBySlug(project.discipline);
          return (
            <li key={project.slug}>
              <h2>
                <Link to={`/projects/${project.slug}`}>{project.title}</Link>
              </h2>
              <p className="meta">
                {discipline?.shortName || project.discipline} · {project.status}
              </p>
              <p>{project.summary}</p>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
